import React from 'react';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';

import config from '../../../config/config';

import LandingPageTile from '../LandingPageTile/LandingPageTile';
import { moduleActions } from '../../../redux/modules/index';
import { getSingleUserSweepAccount } from '../../../redux/modules/transactionLanding/transactionLanding.selectors';

import './SellFromSweepTile.scss';

const SellFromSweepTile = ({
  description,
  icon: Icon,
  singleUserSweepAccount: { agreementID },
  title,
}) => {
  return (
    <LandingPageTile
      description={description}
      className="e2e-sell-sweep-tile"
      icon={Icon}
      link={`${config.url}/usis/transactions/sell?reset=true&productType=MutualFund&selectedAgreementIDs=${agreementID}`}
      title={title}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    singleUserSweepAccount: getSingleUserSweepAccount(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(
    {
      openModal: moduleActions.openModal,
    },
    dispatch
  ),
  dispatch,
});

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  SellFromSweepTile
);
